import React, { FC, ReactNode } from 'react'
import styled from '~/app/components/styled'
import OrderTitle from '~/app/components/order-list/OrderTitle'
import { Typography } from '@yanolja-org/ya-com-core'

/**
 * CardTitle component
 * author: soojin.oh
 */

// type definitions
type Props = {
  title: string
  subTitle: string
  rightAppended?: ReactNode
  fixedTopPosition?: number
}

const CardOrderTitle = styled(OrderTitle)`
  height: 56px;
  padding: 0 2rem;
  border-radius: 0.8rem 0.8rem 0 0;
  border-bottom: solid 0.1rem ${({ theme }) => theme.color.gray200};

  .title {
    ${Typography('subtitle3').bold};
    margin-bottom: 0;
  }
  @media (min-width: 768px) {
    width: 100%;
  }
`

// CardTitle component
const CardTitle: FC<Props> = function ({ title, subTitle, rightAppended }) {
  return <CardOrderTitle title={title} subTitle={subTitle} rightAppended={rightAppended} />
}

export default CardTitle
